import { defineStore } from 'pinia'
import base from './base'
import { backend_api } from '@/utils/api'

export const useContainersStore = defineStore('containers', {
    state: () => ({
        containers: [],
        loading: false,
        selected: null
    }),
    getters: {
        inTransitContainers: (state) => state.containers.filter(container => container.in_transit),
        atDestinationContainers: (state) => state.containers.filter(container => !container.in_transit && container.current_shipment),
        unassignedContainers: (state) => state.containers.filter(container => !container.current_shipment)
    },
    actions: {
        // Reset store
        resetStore() {
            this.containers = []
            this.loading = false
            this.selected = null
        },
        // Mutations
        setContainers: base.actions.setter('containers'),
        removeContainer: base.actions.remover('containers'),

        // Update container with PUT request
        async updateContainer(containerData) {
            try {
                const response = await backend_api.put(`containers/${containerData.uuid}/`, containerData)
                // Update local state
                const index = this.containers.findIndex(c => c.uuid === containerData.uuid)
                if (index !== -1) {
                    this.containers[index] = response.data
                    // Force reactivity
                    this.containers = [...this.containers]
                }
                return response.data
            } catch (error) {
                console.error('Error updating container:', error)
                throw error
            }
        },

        // Actions
        async createContainer(containerData) {
            try {
                const response = await backend_api.post('containers/', containerData)
                this.containers = [...this.containers, response.data]
                return response.data
            } catch (error) {
                console.error('Error creating container:', error)
                throw error
            }
        },

        async fetchContainers() {
            this.loading = true
            try {
                const response = await backend_api.get('containers/')
                this.containers = response.data.results || []
            } catch (error) {
                console.error('Error fetching containers:', error)
            } finally {
                this.loading = false
            }
        },
        async fetchContainerDetail(uuid) {
            try {
                const response = await backend_api.get(`containers/${uuid}/`)
                this.selected = response.data
                return response.data
            } catch (error) {
                console.error('Error fetching container detail:', error)
                throw error
            }
        },
        clearSelected() {
            this.selected = null
        }
    }
})
